import React, { Component } from "react";

// Global Components
import Link from "components/link/link";
import DashedLineBreakHeader from "components/dashedLineBreakHeader/dashedLineBreakHeader";

// Global Assets
import logo from "assets/images/logo.png";

// Local Components
import RichText from "../projects/components/richText/richText";
import ProjectsNavigation from "../projects/components/projectsNavigation/projectsNavigation";

// Local Assets
import "./project.css";
import "./project-mobile.css";

class Project extends Component {
  render() {
    return (
      <div className="project">
        <div className="logo-container">
          <Link to="/">
            <img style={{ maxWidth: "100%" }} src={logo} alt="Hecha Logo" />
          </Link>
        </div>
        <div className="contentContainer">
          <ProjectsNavigation projects={this.props.projects} />
          <div className="content">
            <DashedLineBreakHeader
              title={this.props.project.fields.title}
              first
            />
            <RichText richText={this.props.project.fields.information} />
          </div>
        </div>
      </div>
    );
  }
}

export default Project;
